// Design tokens - orange accent for EventPro
export const accent = "#ea580c"
export const accentShadow = "#c2410c"
export const accentLight = "#fff7ed"
export const accentVeryLight = "#fffbf5"

// Neutral palette (shared with WordPro/ConnectPro)
export const textPrimary = "#0a0a0a"
export const textSecondary = "#555"
export const textMuted = "#999"
export const borderDefault = "#e5e7eb"
export const borderMuted = "#f0f0f0"
export const bgMuted = "#f4f4f4"
export const white = "#ffffff"

// Status colors
export const successGreen = "#4CAF50"
export const successGreenLight = "#f0fdf4"
export const successGreenBorder = "#16a34a"
export const errorRed = "#dc2626"
export const errorRedLight = "#fef2f2"
export const errorRedBorder = "#dc2626"
export const correctGreen = "#16a34a"
export const correctGreenLight = "#f0fdf4"

// Card & container styles
export const cardStyle = {
  backgroundColor: white,
  borderRadius: "12px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.06)",
  padding: "16px 12px",
  marginBottom: "20px",
}

export const sectionLabelStyle = {
  fontSize: "0.7rem",
  fontWeight: "600",
  textTransform: "uppercase",
  letterSpacing: "0.07em",
  color: "#aaa",
  marginBottom: "12px",
}

export const statValueStyle = {
  fontSize: "1.5rem",
  fontWeight: "800",
  color: textPrimary,
}

// Button styles
export const primaryBtn = {
  padding: "13px",
  fontSize: "1rem",
  fontWeight: "bold",
  backgroundColor: accent,
  color: white,
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  boxShadow: `0 2px 0 ${accentShadow}`,
  width: "100%",
  transition: "all 0.1s ease",
  textTransform: "none",
  fontFamily: "inherit",
}

export const primaryBtnHover = {
  ...primaryBtn,
  backgroundColor: accentShadow,
  transform: "translateY(1px)",
  boxShadow: `0 1px 0 ${accentShadow}`,
}

export const secondaryBtn = {
  padding: "11px",
  fontSize: "0.9rem",
  fontWeight: "600",
  border: `2px solid ${accent}`,
  backgroundColor: white,
  color: accent,
  borderRadius: "8px",
  cursor: "pointer",
  transition: "all 0.1s ease",
  fontFamily: "inherit",
}

export const ghostBtn = {
  background: "none",
  border: `1px solid ${borderDefault}`,
  borderRadius: "6px",
  padding: "6px 12px",
  fontSize: "0.85rem",
  color: textSecondary,
  cursor: "pointer",
  transition: "all 0.1s ease",
  fontFamily: "inherit",
}

// Input styles
export const inputStyle = {
  width: "100%",
  padding: "12px 14px",
  fontSize: "16px",
  borderRadius: "8px",
  border: `1px solid ${borderDefault}`,
  boxSizing: "border-box",
  marginBottom: "12px",
  fontFamily: "inherit",
  color: textPrimary,
}

export const inputFocusStyle = {
  ...inputStyle,
  borderColor: accent,
  boxShadow: `0 0 0 3px ${accentLight}`,
  outline: "none",
}

// Modal & overlay
export const modalBackdrop = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0,0,0,0.45)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
}

export const modalPanel = {
  backgroundColor: white,
  borderRadius: "16px",
  padding: "32px",
  maxWidth: "420px",
  width: "90%",
  boxShadow: "0 4px 24px rgba(0,0,0,0.15)",
  animation: "fadeIn 0.2s ease",
}

// Logo styles (matches WordPro/ConnectPro pattern)
export const logoPart = (fontWeight, color) => ({
  fontWeight,
  color,
  fontSize: "1.8rem",
  letterSpacing: "-0.02em",
})

export const logoIconStyle = {
  width: "36px",
  height: "36px",
  borderRadius: "6px",
  backgroundColor: accent,
  color: white,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "1.2rem",
  fontWeight: "900",
  boxShadow: `inset 0 -3px 0 rgba(0,0,0,0.18)`,
  border: `2px solid rgba(0,0,0,0.12)`,
}
